import script from "./GgmsTooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./GgmsTooltip.vue?vue&type=script&lang=ts&setup=true"

import "./GgmsTooltip.vue?vue&type=style&index=0&id=c4d7ca90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4d7ca90"]])

export default __exports__